import { render, staticRenderFns } from "./ApiMenu.vue?vue&type=template&id=28f5e8ea&scoped=true&"
import script from "./ApiMenu.vue?vue&type=script&lang=js&"
export * from "./ApiMenu.vue?vue&type=script&lang=js&"
import style0 from "./ApiMenu.vue?vue&type=style&index=0&id=28f5e8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f5e8ea",
  null
  
)

export default component.exports